import React from "react";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import TextStyle from "../styles/text.style";

interface Props {
  icon?: any
  text: string
  style?: any
}

export default function EmptyState(props: Props) {
  return (
    <div style={{
      display: "flex", justifyContent: "center",
      alignItems: "center", height: 200, width: "100%", alignSelf: "center",
      backgroundColor: "#F2F2F2FF", ...props.style
    }}>
      {props.icon}
      <Typography variant="h2" sx={style.text}>
        {props.text}
      </Typography>
    </div>
  );
}

const style = {
  text: {
    fontFamily: 'Poppins',
    fontStyle: 'normal',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '24px',
    color: '#000000',
    opacity: '0.5',
    width: '100%',
    textAlign: 'center'
  },
}